import React, { useContext, useEffect, useState } from 'react';
import ScreenSizeContext from '../../contexts/ScreenSizeContext';
import './NoItemFound.scss';
import '../../common.scss';
import { Footer } from '../footer/Footer';
import ItemsContext from '../../contexts/ItemsContext';
import FiltersContext from '../../contexts/FiltersContext';
import { validateFiltersFromUrl } from '../../utils/functions';
import { BsSliders, BsList } from 'react-icons/bs';
import { FcAdvance } from "react-icons/fc";
import { Context } from '../../contexts/Context';
// This component is displayed when no results were received from the API call

export const searchPerformed = (): boolean => {
  console.log('url--' + window.location.href );
  return window.location.href.includes("pName=");
};

export const NoItemFound = () => {
  const searched = searchPerformed()
  const screenSizeContext = useContext(ScreenSizeContext);
  const itemsContext = useContext(ItemsContext);
  const filterContext = useContext(FiltersContext);
  const noResult = searched && !filterContext.loading && itemsContext.items.length <= 0;
  const [errors , setErrors] = useState<string[]>([]);
  const { showOffCanvas, setShowOffCanvas } = useContext(Context);
  const handleClick = () => {
    window.location.href = '/?pName=&id=start-laptops-search'; // Replace with your desired URL
       if ((window as any).triggerEmailPopupSearch) {
         (window as any).triggerEmailPopupSearch();
       }
  };

  useEffect(() => {
    const validationErrors = validateFiltersFromUrl();
    setErrors(validationErrors);
  }, [window.location.search]); // Re-run validation when URL parameters change

  return (
    <div className={`notfound-container ${itemsContext.items.length > 0 && 'd-none'}`}>
    {<p className={`no-result-found ${noResult ? 'd-block' : `d-none` }  `}>No Results Found</p>}
    {errors.length > 0 && errors.map((error , index) =>{
      return <p key={index} className={`no-result-found ${noResult ? 'd-block' : `d-none` }  `}>{error}</p>
    })}
    <div
      className={
        'no-item-found-container ' +
        (screenSizeContext.isScreenWidthExtraLarge
          ? 'xl-no-item-found-container'
          : screenSizeContext.isScreenWidthLarge
          ? 'lg-no-item-found-container'
          : 'small-no-item-found-container')
      }
    >
      <div id="ctasection"
        className={
          'no-item-found-content ' +
          (!screenSizeContext.isScreenWidthLarge ? 'small-font-size' : '')
        }
      >			
      <div className="parent">
        <h1>Find the best laptop deals by specs and price across Walmart, Target, DELL & Best Buy!</h1>
         <div className="top-text">
            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mb-2">
                    <button
                        id="start-search-button"
                      className="rounded-pill button-blue border-0 text-white fw-semibold px-3 py-1 my-1 text-center me-2"
                      onClick={() => {
                        handleClick();
                      }}
                    >
                      Start Laptops Search
                    </button>
                    <button
                        id="filter-by-specs-button"
                      className="rounded-pill button-blue border-0 text-white fw-semibold px-3 py-1 my-1 text-center d-block d-lg-none me-2 d-flex align-items-center gap-2 filterbyspecs"
                      onClick={() => setShowOffCanvas(!showOffCanvas)}
                    >
                      <BsSliders />
                      Filter by Specs
                    </button>
              </div>
            <h2 className="mt-3">Why PriceWired?</h2>
            <ul>
                <li className="landing-listitem"><FcAdvance/> Search Target, Walmart, DELL & Best Buy inventories simultaneously!</li>
                <li className="landing-listitem"><FcAdvance/> Standardized search filters across all retailers!</li>
                <li className="landing-listitem"><FcAdvance/> Side-by-side comparison of laptops specs and prices!</li>
            </ul>
            <h2 className="mt-3">How it works?</h2>
            <ul>
                <li className="landing-listitem"><FcAdvance/> Click the button `Start Laptops Search` or `Filter by Specs` and choose technical specs to meet your needs</li>
                <li className="landing-listitem"><FcAdvance/> Review results, adjust price and/or technical specs.</li>
                <li className="landing-listitem"><FcAdvance/> [Optional] Compare laptops using checkboxes for the laptops that interest you.</li>
                <li className="landing-listitem"><FcAdvance/> Ready to buy? Just click on the link provided in the search results to make a purchase on the retailers website.</li>
            </ul>

          </div>
          <div>
            <img
                alt="Sleek laptop"
                src="images/laptop_home.png"
                className="d-inline-block align-top"/>
          </div>
        </div>

      </div>
      <Footer />
    </div>
    </div>
  );
};
